import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../../shared/constants/routes";
import SectionBar from "./SectionBar";
import SectionItemBar from "./SectionItemBar";

import type { CourseSectionData } from "../types";
import { isContentAccessible } from "../utils/access";
import type { AccessRules } from "../utils/access";

interface CourseSectionsProps {
    courseId: string;
    sections: CourseSectionData[];
    rules: AccessRules;
}

// Sections with their lessons and projects, locked or open depending on payment and progress
const CourseSections = ({ courseId, sections, rules }: CourseSectionsProps) => {
    const { lang } = useLanguage();

    return (
        <div>
            {sections.map((section, sectionIndex) => {
                const contents = section.contents ?? [];

                return (
                    <SectionBar
                        key={section.id}
                        title={section.title}
                        rank={sectionIndex + 1}
                        // A section is open if at least one of its items is
                        enabled={contents.some((content) => isContentAccessible(content, rules))}
                    >
                        {contents.map((content, contentIndex) => (
                            <SectionItemBar
                                key={content.id}
                                title={content.title}
                                hasBBorder={contentIndex !== contents.length - 1}
                                to={ROUTES.myCourseContentItem(lang, courseId, content.id)}
                                typ={content.type}
                                enabled={isContentAccessible(content, rules)}
                                xp={content.xp}
                                credit={content.credit}
                            />
                        ))}
                    </SectionBar>
                );
            })}
        </div>
    );
};

export default CourseSections;